import { Header, Left, Body, Right, Content, Title, Button, H2, List, Container, Icon, Text, H3, ListItem, Thumbnail, View, Tabs, Tab, Switch, Label, Item, CardItem } from 'native-base';
import { Platform, Linking, StyleSheet, Image } from 'react-native';
import React, { useState, useEffect, useCallback } from 'react';
import * as WebBrowser from 'expo-web-browser';
import HamburgerMenu from '../../components/hamburgerMenu';
import CalCalDataApi from '../../api/CalCalDataApi';
import { useSelector, shallowEqual } from 'react-redux';
import Alert from '../../components/alert';
import Table from '../../components/table';
import { isArray, xor } from 'lodash';
import TransactionAdder from './transactionAdder';
import { renderSwitch } from '../../forms/renderedComponents';

import { createIconSetFromFontello } from '@expo/vector-icons';
import transactiontypesConfig from '../../../assets/fonts/transactiontypes.json';
import DatePicker from '../../components/rn-datepicker';
const TTIcon = createIconSetFromFontello(transactiontypesConfig, 'transactiontypes', 'transactiontypes.ttf');

export default function Transactions({ navigation, jwt, accounts, categories, search }) {
	const [filters, setFilters] = useState();

	const [transactions, setTransactions] = useState([]);
	const [page, setPage] = useState(0);
	const [previousPage, setPreviousPage] = useState();
	const [sort, setSort] = useState('date');
	const [direction, setDirection] = useState('descending');
	const [fetching, setFetching] = useState(false);
	const [atLastPage, setAtLastPage] = useState(false);
	const [loadingFirst, setLoadingFirst] = useState(true);

	const [filterAccounts, setFilterAccounts] = useState([]);
	const [fromDate, setFromDate] = useState(() => {
		var d = new Date();
		d.setMonth(d.getMonth() - 3);
		return d;
	});
	const [toDate, setToDate] = useState(new Date());

	const [selectedTrans, setSelectedTrans] = useState();
	const [showImported, setShowImported] = useState(false);
	const PAGESIZE = 50;

	useEffect(() => {
		var filtered = {};
		var accesstokens = [];
		accounts.forEach(acc => {
			if (acc.calcalId) {
				if (!filtered[acc.access_token]) filtered[acc.access_token] = [];
				filtered[acc.access_token].push(acc.account_id);
			}
		});

		setTransactions([]);
		setLoadingFirst(true);
		setFilterAccounts(filtered);
	}, [accounts]);
	//console.log(search, direction, sort);
	useEffect(() => {
		if (!Object.keys(filterAccounts)?.length) return;
		const data = {
			sort: sort.replace('Id', '').toUpperCase(),
			order: direction == 'ascending' ? 'ASC' : 'DESC',
			limit: PAGESIZE,
			offset: page * PAGESIZE,
			queryString: search || '',
			clientIds: filterAccounts,
			fromDate,
			toDate
		};
		__DEV__ && console.log(data);
		if (page == 0) {
			setTransactions([]);
			setLoadingFirst(true);
		}
		setFetching(true);
		CalCalDataApi.dataInsert('bankimport/transactions', data, jwt, res => {
			setLoadingFirst(false);
			setFetching(false);
			//fiddle the data on ea transaction to speed up render
			if (res.success) {
				const newTrans = res.transactions.map((transaction, i) => {
					transaction.categoryTypeColour = transaction.amount >= 0 ? '#006622' : '#b30000';
					transaction.importedIcon = transaction.de_id ? 'ios-checkmark-circle-outline' : null;
					transaction.id = transaction.transaction_id;
					return transaction;
				});

				if (isArray(newTrans)) setTransactions(page > previousPage ? [...transactions, ...newTrans] : newTrans);
				setAtLastPage(res.transactions.length < PAGESIZE);
				setPreviousPage(page);
			}
		});
	}, [page, sort, direction, filters, search, filterAccounts, fromDate, toDate]);
	/*
	useEffect(() => {
		//change query
		setTransactions([]);
		setPage(0);
		setAtLastPage(false);
		setFilters(filters + 1); //wait wha
	}, [showImported]);*/

	//__DEV__ && console.log(accounts);

	const changeSort = useCallback(
		sortby => {
			//setTransactions([]);
			__DEV__ && console.log(sort, sortby, direction); //keep!!
			if (sortby == sort) {
				setDirection(direction == 'ascending' ? 'descending' : 'ascending');
			} else {
				setDirection('ascending');
			}
			setPage(0);
			setAtLastPage(false);
			setSort(sortby);
		},
		[direction]
	);

	const updateItem = useCallback(
		changes => {
			//find trensaction in transactions by id. fix it
			var changedTrans = [...transactions];
			var index = _.findIndex(changedTrans, { id: changes.id });
			var item = { ...changedTrans.splice(index, 1)[0], ...changes };
			__DEV__ && console.log('found at index', index, item);
			changedTrans.splice(index, 0, item);
			setTransactions([...changedTrans]);
		},
		[transactions]
	);

	const onRowSelect = useCallback(
		row => {
			__DEV__ && console.log(row, row?.id);
			setSelectedTrans(row?.id);
		},
		[showImported]
	);

	//listener for navigate back. Check the selectedTrans (single) and if it's got a de_id can filter it

	if (!categories || !accounts) return null;

	if (!Object.keys(filterAccounts)?.length) return <Text>Your bank accounts are not linked to CalCal accounts. Tap on an account to link it to an account in CalCal</Text>;
	return (
		<>
			<CardItem style={{ flexWrap: 'wrap', backgroundColor: '#D7D7D7' }}>
				<View style={{ flexDirection: 'row', alignItems: 'center' }}>
					<Text>Between </Text>

					<DatePicker
						date={fromDate.toISOString().split('T')[0]}
						style={{ width: 110 }}
						mode="date"
						placeholder=""
						format="YYYY-MM-DD"
						confirmBtnText="Confirm"
						cancelBtnText="Cancel"
						displayFormat="DD/MM/YY"
						showIcon={false}
						customStyles={{
							dateInput: {
								paddingLeft: 5,
								borderColor: 'rgba(0, 0, 0, 0)'
								//alignItems: 'flex-end'
							}
						}}
						onDateChange={v => setPage(0) || setFromDate(v)}
					/>
					<Text> and </Text>
					<DatePicker
						date={toDate.toISOString().split('T')[0]}
						style={{ width: 110 }}
						mode="date"
						placeholder=""
						format="YYYY-MM-DD"
						confirmBtnText="Confirm"
						cancelBtnText="Cancel"
						displayFormat="DD/MM/YY"
						showIcon={false}
						customStyles={{
							dateInput: {
								paddingLeft: 5,
								borderColor: 'rgba(0, 0, 0, 0)'
								//alignItems: 'flex-end'
							}
						}}
						onDateChange={v => setPage(0) || setToDate(v)}
					/>
				</View>
				<View style={{ flexDirection: 'row', alignItems: 'center' }}>
					<Label style={{ paddingRight: 10 }}>
						<Text>Show imported transactions</Text>
					</Label>
					<Switch value={showImported} onValueChange={setShowImported} />
				</View>
			</CardItem>
			<Table
				data={showImported ? transactions : transactions.filter(v => !v.de_id)}
				CustomIcon={TTIcon}
				smallWidth={450}
				cols={[
					{ name: 'date', title: 'Date', width: 85, sortable: true, renderer: 'date' },
					{
						name: 'categoryType',
						title: 'Type',
						width: 30,
						icon: 'transactionTypeIcon',
						iconFont: 'TransactionTypes',
						iconColour: 'categoryTypeColour',
						hideText: true
						/*renderer: v => (
						<Icon name={v == 'INCOME' ? 'log-in' : v == 'EXPENSES' ? 'log-out' : 'arrow-round-forward'} style={{ color: v == 'INCOME' ? '#006622' : v == 'EXPENSES' ? '#b30000' : 'blue' }} />
					)*/
					},
					{
						name: 'category',
						title: 'Category',
						hideSmall: true,
						width: 80,
						sortable: true,
						renderer: c => c[c.length - 1] || c[c.length - 2]
					},
					{ name: 'de_id', icon: 'importedIcon', hideText: true, width: 30, visible: showImported },
					{ name: 'name', title: 'Description', flex: 1.3, sortable: true },
					{ name: 'amount', title: 'Amount', width: 65, numeric: true, sortable: true, renderer: 'money' },
					{
						name: 'accountName',
						title: 'Account',
						flex: 0.8,
						sortable: true,
						style: { marginLeft: 10 },
						hideSmall: true,
						widthSmall: 34,
						//renderer: v => accounts.find(a => a.id == v)?.name,
						avatar: 'accountIcon'
					}
				]}
				rowAlt="#EDEDED"
				sort={sort}
				direction={direction}
				setSort={changeSort}
				//dataInProperty="transaction"
				loading={loadingFirst}
				loadMoreData={() => !atLastPage && setPage(page + 1)}
				refreshing={fetching}
				onRowPress={onRowSelect}
				selectedId={selectedTrans}
				selectedItemRow={item => <TransactionAdder {...{ item, categories, navigation, jwt, updateItem }} />}
			/>
		</>
	);
}
